module.exports = __webpack_public_path__ + "static/media/flag-spain-round.55e3dab1.png";